<template>
  <div>
    <div class="mt-3">
      <div class="text-2xl font-semibold">A - BỆNH ÁN</div>
      <div class="text-lg font-semibold mt-2.5">I. LÝ DO VÀO VIỆN</div>
      <EditorInput
        :disabled="!isEdit"
        id="visit_reasons-bavv"
        :prop_text="form.visit_reasons"
        @onChangeContent="(content) => (form.visit_reasons = content)"
      />
    </div>

    <div class="mt-3">
      <div class="text-lg font-semibold">II. HỎI BỆNH</div>

      <div class="mt-2">
        <label class="fs-18 fw-400 txt-grey-900">
          <span class="font-bold">1. Quá trình bệnh lý:</span>
          <!-- (khởi phát, diễn
          biến, chẩn đoán, điều trị của
          tuyến dưới v.v...)-->
        </label>
        <EditorInput
          :disabled="!isEdit"
          id="pathological-bavv"
          :prop_text="form.pathological"
          @onChangeContent="(content) => (form.pathological = content)"
        />
      </div>

      <div class="mt-2.5">
        <label class="font-bold fs-18 txt-grey-900">2.Tiền sử bệnh</label>
        <div>
          <span class="font-bold">Bản thân:</span>
          <!-- (phát triển thể lực từ nhỏ đến lớn, những bệnh đã
          mắc, phương pháp ĐTr, tiêm phòng,
          ăn uống, sinh hoạt vv...)-->
        </div>
        <EditorInput
          :disabled="!isEdit"
          id="anamnesis_self-bavv"
          :prop_text="form.anamnesis_self"
          @onChangeContent="(content) => (form.anamnesis_self = content)"
        />
        <div class="mt-2.5">
          <span class="font-bold">Gia đình:</span>
          <!-- (Những người trong gia đình: bệnh đã mắc, đời
          sống, tinh thần, vật chất v.v...)-->
        </div>
        <EditorInput
          :disabled="!isEdit"
          id="anamnesis_family-bavv"
          :prop_text="form.anamnesis_family"
          @onChangeContent="(content) => (form.anamnesis_family = content)"
        />

        <div class="mt-2.5">
          <label class="font-bold fs-18 txt-grey-900"
            >3.Đặc điểm liên quan đến bệnh</label
          >
          <i class="ml-1 fs-13">(1. Có, 2. Không)</i>
        </div>

        <div class="mt-1 row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-md-2">Ký hiệu</div>
              <div class="col-md-7 fs-14 txt-grey-900">
                Thời gian (tính theo tháng)
              </div>
            </div>
            <div class="row mt-2.5">
              <div class="col-md-3 fs-14 txt-grey-900">Dị ứng</div>
              <div class="col-md-2 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_01_code"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
              <div class="col-md-7 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_01_time"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
            </div>
            <div class="row mt-2.5">
              <div class="col-md-3 fs-14 txt-grey-900">Ma tuý</div>
              <div class="col-md-2 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_02_code"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
              <div class="col-md-7 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_02_time"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
            </div>
            <div class="row mt-2.5">
              <div class="col-md-3 fs-14 txt-grey-900">Rượu bia</div>
              <div class="col-md-2 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_03_code"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
              <div class="col-md-7 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_03_time"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-md-2">Ký hiệu</div>
              <div class="col-md-7 fs-14 txt-grey-900">
                Thời gian (tính theo tháng)
              </div>
            </div>
            <div class="row mt-2.5">
              <div class="col-md-3 fs-14 txt-grey-900 text-right">Thuốc lá</div>
              <div class="col-md-2 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_04_code"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
              <div class="col-md-7 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_04_time"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
            </div>
            <div class="row mt-2.5">
              <div class="col-md-3 fs-14 txt-grey-900 text-right">
                Thuốc lào
              </div>
              <div class="col-md-2 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_05_code"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
              <div class="col-md-7 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_05_time"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
            </div>
            <div class="row mt-2.5">
              <div class="col-md-3 fs-14 txt-grey-900 text-right">Khác</div>
              <div class="col-md-2 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_06_code"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
              <div class="col-md-7 fs-14 txt-grey-900">
                <input
                  v-model="form.disease_related_06_time"
                  :readonly="!isEdit"
                  type="text"
                  class="form--input txt-grey-900"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <div class="text-lg font-semibold">III. KHÁM BỆNH</div>

      <div class="mt-2">
        <label class="fs-18 fw-400 txt-grey-900">
          <span class="font-bold">1. Toàn thân:</span>
          <!-- (ý
          thức, da niêm mạc, hệ thống hạch, tuyến giáp, vị trí, kích thước, số lượng, di động v.v...)-->
        </label>
        <EditorInput
          :disabled="!isEdit"
          id="exam_body-bavv"
          :prop_text="form.exam_body"
          @onChangeContent="(content) => (form.exam_body = content)"
        />
      </div>

      <div class="mt-2.5">
        <div class="mt-2.5 row">
          <div class="col-md">
            <div class="fs-14 txt-grey-900">Mạch (lần/phút)</div>
            <div class="fs-14 txt-grey-900">
              <input
                v-model="form.exam_pulse"
                :readonly="!isEdit"
                type="text"
                class="form--input txt-grey-900"
              />
            </div>
          </div>
          <div class="col-md">
            <div class="fs-14 txt-grey-900">Nhiệt độ (độ C)</div>
            <div class="fs-14 txt-grey-900">
              <input
                v-model="form.exam_temperature"
                :readonly="!isEdit"
                type="text"
                class="form--input txt-grey-900"
              />
            </div>
          </div>
          <div class="col-md">
            <div class="fs-14 txt-grey-900">Huyết áp (mmHg)</div>
            <div class="fs-14 txt-grey-900">
              <input
                v-model="form.exam_blood_pressure"
                :readonly="!isEdit"
                type="text"
                class="form--input txt-grey-900"
              />
            </div>
          </div>
          <div class="col-md">
            <div class="fs-14 txt-grey-900">Nhịp thở (lần/phút)</div>
            <div class="fs-14 txt-grey-900">
              <input
                v-model="form.exam_breathing"
                :readonly="!isEdit"
                type="text"
                class="form--input txt-grey-900"
              />
            </div>
          </div>
          <div class="col-md">
            <div class="fs-14 txt-grey-900">Cân nặng (kg)</div>
            <div class="fs-14 txt-grey-900">
              <input
                v-model="form.exam_weight"
                :readonly="!isEdit"
                type="text"
                class="form--input txt-grey-900"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <label class="fs-18 txt-grey-900">
          <span class="font-bold">2. Khám bộ phận tổn thương:</span>
        </label>
        <EditorInput
          :disabled="!isEdit"
          id="exam_wound_desc-bavv"
          :prop_text="form.exam_wound_desc"
          @onChangeContent="(content) => (form.exam_wound_desc = content)"
        />
      </div>

      <div class="mt-3">
        <label class="block fs-14 txt-grey-900 mb-3 whitespace-nowrap"
          >Hình vẽ hoặc ảnh</label
        >
        <div class="flex items-start">
          <div class="w-32 flex flex-col justify-center items-center mr-4">
            <svg
              width="160"
              height="160"
              viewBox="0 0 102 102"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <rect
                x="0.474609"
                y="0.474609"
                width="101.508"
                height="101.508"
                fill="url(#pattern0)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlink:href="#image0_20662_92439"
                    transform="scale(0.005)"
                  />
                </pattern>
                <image
                  id="image0_20662_92439"
                  width="200"
                  height="200"
                  xlink:href="data:image/png;base64,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"
                />
              </defs>
            </svg>
            <div class="flex justify-center items-center">
              <!-- <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.364 11.5234V17.5234C22.364 21.5234 21.364 22.5234 17.364 22.5234H7.36401C3.36401 22.5234 2.36401 21.5234 2.36401 17.5234V7.52344C2.36401 3.52344 3.36401 2.52344 7.36401 2.52344H8.86401C10.364 2.52344 10.694 2.96344 11.264 3.72344L12.764 5.72344C13.144 6.22344 13.364 6.52344 14.364 6.52344H17.364C21.364 6.52344 22.364 7.52344 22.364 11.5234Z"
                  stroke="#292D32"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                />
              </svg>-->
              <div
                class="h-10 flex items-center cursor-pointer"
                @click="handleAddImage"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.0001 29.3337C23.3334 29.3337 29.3334 23.3337 29.3334 16.0003C29.3334 8.66699 23.3334 2.66699 16.0001 2.66699C8.66675 2.66699 2.66675 8.66699 2.66675 16.0003C2.66675 23.3337 8.66675 29.3337 16.0001 29.3337Z"
                    stroke="#476DD6"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.6667 16H21.3334"
                    stroke="#476DD6"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 21.3337V10.667"
                    stroke="#476DD6"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div class="ml-2.5 fs-16 fw-600 text-primary">Thêm</div>

                <input
                  type="file"
                  :disabled="!isEdit"
                  ref="inputFile"
                  @change="handleFileSelected($event)"
                  accept="image/*"
                  class="d-none"
                />
              </div>
              <!-- <div class="fs-16 fw-600 ml-1.5 whitespace-nowrap">
                Hình ảnh
                <span class="text-primary">({{ attachmentsChild.length }})</span>
              </div>-->
            </div>
          </div>

          <div>
            <div class="flex flex-wrap -mx-3" v-if="attachmentsChild.length">
              <div
                class="flex items-center gap-2 flex-col justify-center mb-3 px-3"
                v-for="(item, index) in attachmentsChild"
                :key="index"
              >
                <div class="relative w-40 h-40 mr-2">
                  <img
                    class="w-full h-full border border-solid border-gray-600"
                    :src="item.url"
                    :alt="item.name || 'Image'"
                    @click="indexMedia = index"
                  />
                </div>
                <div class="relative w-full">
                  <div>{{ truncateHash(item.name, 10) }}</div>
                  <div
                    style="width: 20px; height: 20px"
                    class="flex items-center justify-center absolute top-0 right-0 rounded-full border border-solid border-gray-600 text-black z-10 transition-all duration-200 cursor-pointer"
                  >
                    <div class="dropdown">
                      <img
                        src="../../../../public/assets/images/icon/icon-more.svg"
                        class="dropdown-toggle w-full h-full"
                        data-toggle="dropdown"
                      />
                      <div
                        class="dropdown-menu item-drop z-10 relative cs-dropdown"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a
                          @click="showModalDrawImage(item, index)"
                          class="dropdown-item fs-16"
                        >
                          <img
                            class="mr-2"
                            src="../../../../public/assets/images/icon/icon-edit-2.svg"
                          />
                          Sửa
                        </a>

                        <a
                          class="dropdown-item fs-16"
                          href="javascript:;"
                          @click="onDeleteFile(item, index)"
                        >
                          <img
                            class="mr-3"
                            src="../../../../public/assets/images/icon/icon-trash-2.svg"
                          />
                          Xoá
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <label class="fs-18 txt-grey-900">
          <span class="font-bold">3. Các cơ quan khác</span>
        </label>

        <div class="mt-2.5">
          <label class="fs-14 txt-grey-900">Thần Kinh:</label>
          <!-- Hội chứng não, màng não (-) -->
          <EditorInput
            :disabled="!isEdit"
            id="part_neurological-bavv"
            :prop_text="form.part_neurological"
            @onChangeContent="(content) => (form.part_neurological = content)"
          />
          <!-- <input v-model="form.part_neurological" :readonly="!isEdit" type="text" class="form--input txt-grey-900" /> -->
        </div>

        <div class="mt-2.5">
          <label class="fs-14 txt-grey-900">Tuần hoàn:</label>
          <EditorInput
            :disabled="!isEdit"
            id="part_circulatory-bavv"
            :prop_text="form.part_circulatory"
            @onChangeContent="(content) => (form.part_circulatory = content)"
          />
          <!-- <input v-model="form.part_circulatory" :readonly="!isEdit" type="text" class="form--input txt-grey-900" /> -->
        </div>
        <div class="mt-2.5">
          <label class="fs-14 txt-grey-900">Hô hấp</label>
          <EditorInput
            :disabled="!isEdit"
            id="part_respiratory-bavv"
            :prop_text="form.part_respiratory"
            @onChangeContent="(content) => (form.part_respiratory = content)"
          />
          <!-- <input v-model="form.part_respiratory" :readonly="!isEdit" type="text" class="form--input txt-grey-900" /> -->
        </div>
        <div class="mt-2.5">
          <label class="fs-14 txt-grey-900">Tiêu hoá</label>
          <EditorInput
            :disabled="!isEdit"
            id="part_digestion-bavv"
            :prop_text="form.part_digestion"
            @onChangeContent="(content) => (form.part_digestion = content)"
          />
          <!-- <input v-model="form.part_digestion" :readonly="!isEdit" type="text" class="form--input txt-grey-900" /> -->
        </div>
        <div class="mt-2.5">
          <label class="fs-14 txt-grey-900">Cơ- Xương- Khớp</label>
          <EditorInput
            :disabled="!isEdit"
            id="part_bone-bavv"
            :prop_text="form.part_bone"
            @onChangeContent="(content) => (form.part_bone = content)"
          />
          <!-- <input v-model="form.part_bone" :readonly="!isEdit" type="text" class="form--input txt-grey-900" /> -->
        </div>
        <div class="mt-2.5">
          <label class="fs-14 txt-grey-900">Tiết niệu</label>
          <EditorInput
            :disabled="!isEdit"
            id="part_urinary-bavv"
            :prop_text="form.part_urinary"
            @onChangeContent="(content) => (form.part_urinary = content)"
          />
          <!-- <input v-model="form.part_urinary" :readonly="!isEdit" type="text" class="form--input txt-grey-900" /> -->
        </div>
        <div class="mt-2.5">
          <label class="fs-14 txt-grey-900">Sinh dục</label>
          <EditorInput
            :disabled="!isEdit"
            id="part_genital-bavv"
            :prop_text="form.part_genital"
            @onChangeContent="(content) => (form.part_genital = content)"
          />
          <!-- <input v-model="form.part_genital" :readonly="!isEdit" type="text" class="form--input txt-grey-900" /> -->
        </div>
        <div class="mt-2.5">
          <label class="fs-14 txt-grey-900">Khác</label>
          <EditorInput
            :disabled="!isEdit"
            id="part_other-bavv"
            :prop_text="form.part_other"
            @onChangeContent="(content) => (form.part_other = content)"
          />
          <!-- <input v-model="form.part_other" :readonly="!isEdit" type="text" class="form--input txt-grey-900" /> -->
        </div>
      </div>

      <div class="mt-3">
        <label class="fs-18 txt-grey-900">
          <span class="font-bold">
            4. Các xét nghiệm cận lâm sàng cần làm
          </span>
        </label>
        <EditorInput
          :disabled="!isEdit"
          id="laboratory_test-bavv"
          :prop_text="form.laboratory_test"
          @onChangeContent="(content) => (form.laboratory_test = content)"
        />
      </div>

      <div class="mt-3">
        <label class="fs-18 txt-grey-900">
          <span class="font-bold">5. Tóm tắt bệnh án</span>
        </label>
        <EditorInput
          :disabled="!isEdit"
          id="exam_summary-bavv"
          :prop_text="form.exam_summary"
          @onChangeContent="(content) => (form.exam_summary = content)"
        />
      </div>
    </div>

    <div class="mt-3">
      <div class="text-lg font-semibold">
        IV. Chẩn đoán khi vào khoa điều trị
      </div>

      <div class="mt-2.5 row">
        <div class="col-md-9">
          <label class="fs-14 txt-grey-900">Bệnh chính</label>
          <input
            v-model="form.treat_dept_main_name"
            :readonly="!isEdit"
            type="text"
            class="form--input txt-grey-900"
          />
        </div>
        <div class="col-md-3">
          <label class="fs-14 txt-grey-900">Mã</label>
          <input
            v-model="form.treat_dept_main_code"
            :readonly="!isEdit"
            type="text"
            class="form--input txt-grey-900"
          />
        </div>
      </div>

      <div class="mt-2 col-lg-6 row">
        <div class="col-md-3">
          <label class="fs-14 txt-grey-900">T</label>
          <input
            v-model="form.treat_dept_t_value"
            :readonly="!isEdit"
            type="text"
            class="form--input txt-grey-900"
          />
        </div>
        <div class="col-md-3">
          <label class="fs-14 txt-grey-900">N</label>
          <input
            v-model="form.treat_dept_n_value"
            :readonly="!isEdit"
            type="text"
            class="form--input txt-grey-900"
          />
        </div>
        <div class="col-md-3">
          <label class="fs-14 txt-grey-900">M</label>
          <input
            v-model="form.treat_dept_m_value"
            :readonly="!isEdit"
            type="text"
            class="form--input txt-grey-900"
          />
        </div>
        <div class="col-md-3">
          <label class="fs-14 txt-grey-900">Giai đoạn</label>
          <input
            v-model="form.treat_dept_disease_stage"
            :readonly="!isEdit"
            type="text"
            class="form--input txt-grey-900"
          />
        </div>
      </div>

      <div class="mt-2 row">
        <div class="col-md-9">
          <label class="fs-14 txt-grey-900">Bệnh kèm theo (nếu có):</label>
          <input
            v-model="form.treat_dept_including_name"
            :readonly="!isEdit"
            type="text"
            class="form--input txt-grey-900"
          />
        </div>
        <div class="col-md-3">
          <label class="fs-14 txt-grey-900">Mã</label>
          <input
            v-model="form.treat_dept_including_code"
            :readonly="!isEdit"
            type="text"
            class="form--input txt-grey-900"
          />
        </div>
      </div>

      <div class="mt-2">
        <label class="fs-14 txt-grey-900">Phân biệt:</label>
        <input
          v-model="form.treat_dept_separate"
          :readonly="!isEdit"
          type="text"
          class="form--input txt-grey-900"
        />
      </div>
    </div>

    <div class="mt-3">
      <div class="text-lg font-semibold mt-2.5">V. Tiên lượng</div>
      <EditorInput
        :disabled="!isEdit"
        id="exam_prognosis-bavv"
        :prop_text="form.exam_prognosis"
        @onChangeContent="(content) => (form.exam_prognosis = content)"
      />
    </div>

    <div class="mt-3">
      <div class="text-lg font-semibold mt-2.5">VI. Hướng điều trị</div>
      <EditorInput
        :disabled="!isEdit"
        id="treatment_direction-bavv"
        :prop_text="form.treatment_direction"
        @onChangeContent="(content) => (form.treatment_direction = content)"
      />
    </div>

    <div class="mt-3">
      <div>
        <label class="fs-16 txt-grey-900 mt-2.5">Chế độ ăn uống bệnh lý</label>
        <div class="flex mt-2">
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              :disabled="!isEdit"
              type="radio"
              id="nutritional_option_0"
              :value="0"
              class="mr-2"
              v-model="form.nutritional_option"
            />
            <span>0. Nhịn ăn</span>
          </label>
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              type="radio"
              :disabled="!isEdit"
              id="nutritional_option_1"
              :value="1"
              class="mr-2"
              v-model="form.nutritional_option"
            />
            <span>1. Lỏng</span>
          </label>
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              type="radio"
              :disabled="!isEdit"
              id="nutritional_option_2"
              :value="2"
              class="mr-2"
              v-model="form.nutritional_option"
            />
            <span>2. Cháo</span>
          </label>
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              type="radio"
              :disabled="!isEdit"
              id="nutritional_option_3"
              :value="3"
              class="mr-2"
              v-model="form.nutritional_option"
            />
            <span>3. Cơm</span>
          </label>
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              type="radio"
              :disabled="!isEdit"
              id="nutritional_option_4"
              :value="4"
              class="mr-2"
              v-model="form.nutritional_option"
            />
            <span>4. Tự do</span>
          </label>
          <label class="d-flex align-items-center mr-4">
            <button
              @click="form.nutritional_option = null"
              class="bg-blue-500 hover:bg-blue-700 text-white rounded-full border-0 whitespace-nowrap"
            >
              Chọn lại
            </button>
          </label>
        </div>
      </div>
      <div>
        <label class="fs-16 txt-grey-900 mt-2.5">Kiêng</label>
        <div class="flex mt-2">
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              :disabled="!isEdit"
              type="radio"
              id="abstinence_1"
              :value="1"
              class="mr-2"
              v-model="form.abstinence"
            />
            <span>1. Muối</span>
          </label>
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              type="radio"
              :disabled="!isEdit"
              id="abstinence_2"
              :value="2"
              class="mr-2"
              v-model="form.abstinence"
            />
            <span>2. Mỡ</span>
          </label>
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              type="radio"
              :disabled="!isEdit"
              id="abstinence_3"
              :value="3"
              class="mr-2"
              v-model="form.abstinence"
            />
            <span>3. Đường</span>
          </label>
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              type="radio"
              :disabled="!isEdit"
              id="abstinence_4"
              :value="4"
              class="mr-2"
              v-model="form.abstinence"
            />
            <span>4. Khác</span>
          </label>
          <label class="d-flex align-items-center mr-4">
            <button
              @click="form.abstinence = null"
              class="bg-blue-500 hover:bg-blue-700 text-white rounded-full border-0 whitespace-nowrap"
            >
              Chọn lại
            </button>
          </label>
        </div>
      </div>
      <div>
        <label class="fs-16 txt-grey-900 mt-2.5">Chế độ chăm sóc</label>
        <div class="flex mt-2">
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              :disabled="!isEdit"
              type="radio"
              id="care_option_1"
              :value="1"
              class="mr-2"
              v-model="form.care_option"
            />
            <span>1. Cấp 1</span>
          </label>
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              type="radio"
              :disabled="!isEdit"
              id="care_option_2"
              :value="2"
              class="mr-2"
              v-model="form.care_option"
            />
            <span>2. Cấp 2</span>
          </label>
          <label class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
            <input
              type="radio"
              :disabled="!isEdit"
              id="care_option_3"
              :value="3"
              class="mr-2"
              v-model="form.care_option"
            />
            <span>3. Cấp 3</span>
          </label>
          <label class="d-flex align-items-center mr-4">
            <button
              @click="form.care_option = null"
              class="bg-blue-500 hover:bg-blue-700 text-white rounded-full border-0 whitespace-nowrap"
            >
              Chọn lại
            </button>
          </label>
        </div>
      </div>
    </div>

    <!-- <div class="mt-3">
      <div class="text-lg uppercase font-semibold mt-2.5">Bác sĩ làm bệnh án</div>
      <input
        v-model="form.created_by_doctor_name"
        :readonly="!isEdit"
        type="text"
        class="form--input txt-grey-900"
      />
    </div> -->

    <div
      class="modal top fade"
      id="modalDrawImageBAVV"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-fullscreen" role="document">
        <div class="modal-content">
          <div class="d-flex justify-content-between p-3">
            <div class="fs-24 fw-700 txt-grey-900 text-center w-100"></div>
            <button
              type="button"
              class="close bg-white border-0"
              @click="closeModalDrawImage()"
            >
              <span class="fs-30 fw-500">&times;</span>
            </button>
          </div>
          <div class="modal-body flex items-center justify-center p-0">
            <DrawImage
              :imageProp="imageFileSelected"
              @onSaveFile="handleSaveDrawImage"
            />
          </div>
        </div>
      </div>
    </div>

    <CoolLightBox
      :items="getImagesForCoolight(attachmentsChild)"
      :index="indexMedia"
      :useZoomBar="true"
      @close="indexMedia = null"
    ></CoolLightBox>
  </div>
</template>


<script>
import EditorInput from '@/components/EditorInput.vue'
import DrawImage from '@/components/DrawImage.vue'

export default {
  name: 'ABenhAn',
  props: ['form', 'attachments', 'isEdit'],
  components: { EditorInput, DrawImage },
  data () {
    return {
      attachmentsChild: [],
      indexMedia: null,
      count: 0,
      imageFileSelected: null,
      selectedImage: null
    }
  },
  watch: {
    attachments () {
      this.attachmentsChild = this.attachments
    },
    'attachmentsChild.length' (length) {
      this.count = length
    }
  },
  mounted () {
    if (this.attachments) this.attachmentsChild = this.attachments
  },
  methods: {
    uploadFile () {
      this.$refs.inputFile.click()
      this.$refs.inputFile.value = null
    },
    handleFileSelected (e) {
      const self = this
      const files = e.target.files
      if (files) {
        if (this.count >= 2) {
          self.$message({
            type: 'warning',
            message: self.$t('Bạn chỉ được tải lên 2 hình ảnh')
          })
          self.$refs.inputFile.value = null
          return
        }
        for (let i = 0; i < files.length; i++) {
          const f = files[i]
          const url = self.onHandleCreateObjectURL(f)

          f.url = url
          self.attachmentsChild.push(f)
        }
      }
      self.$refs.inputFile.value = null
      this.$emit('uploadFile', self.attachmentsChild)
    },
    onHandleCreateObjectURL (file) {
      if (!file) return ''
      if (file instanceof File) {
        return URL.createObjectURL(file)
      }
      return file
    },
    async onDeleteFile (item, index) {
      this.attachmentsChild.splice(index, 1)
      this.$emit('uploadFile', this.attachmentsChild)

      if (!item?.id) return

      try {
        const params = {
          mr_master_id: item?.medical_record_master_id
        }
        await this.$rf
          .getRequest('DoctorRequest')
          .deleteEmrExamWoundAttachment(item.id, params)
      } catch (error) {
        console.log(error)
      }
    },
    getImagesForCoolight (files) {
      let results = []
      if (files) {
        files.forEach((file) => {
          results.push({
            src: file?.url
          })
        })
      }
      return results
    },
    convertString (value, length = 4) {
      const strArr = value.split('.')
      return strArr[0] && strArr[0].length > 20
        ? `${strArr[0]?.slice(0, length)}${length > 0 ? '...' : ''}${
          length > 0
            ? strArr[0]?.slice(strArr[0]?.length - length, strArr[0].length)
            : ''
        }.${strArr[strArr.length - 1]}`
        : value || ''
    },
    async showModalDrawImage (imageData, index) {
      if (imageData?.url && typeof imageData.url === 'string') {
        try {
          const newImageSrc = new URLSearchParams(imageData.url).toString()
          const formatImageSrc = newImageSrc.substring(
            0,
            newImageSrc.length - 1
          )
          const response = await this.$rf
            .getRequest('DoctorRequest')
            .postUrlImage(formatImageSrc)
          const base64File = response.data?.data || ''
          const fileName = imageData.url.substring(
            imageData.url.lastIndexOf('/') + 1
          )
          const newFile = this.convertBase64tToFile(base64File, fileName)
          this.imageFileSelected = newFile
        } catch (error) {
          console.log(error)
        }
      } else if (!imageData) {
        const newFile = new File([0], `image-${index + Math.random()}.png`, {
          type: 'image/png'
        })
        this.imageFileSelected = newFile
      } else {
        this.imageFileSelected = imageData
      }

      this.selectedImage = index
      window.$('#modalDrawImageBAVV').modal('show')
    },
    blobToFile (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    convertBase64tToFile (dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    closeModalDrawImage () {
      this.imageFileSelected = ''
      this.selectedImage = ''
      window.$('#modalDrawImageBAVV').modal('hide')
    },
    handleSaveDrawImage (file, base64) {
      file.url = base64
      this.attachmentsChild[this.selectedImage] = file
      this.$emit('uploadFile', this.attachmentsChild)

      this.closeModalDrawImage()
    },
    handleAddImage () {
      if (this.attachmentsChild.length >= 2) {
        this.$message({
          type: 'warning',
          message: this.$t('Bạn chỉ được tải lên 2 hình ảnh')
        })

        return
      }

      this.showModalDrawImage('', this.attachmentsChild.length)
    },

    truncateHash (address, startLength = 4, endLength = 4) {
      if (!address) return ''
      return `${address.substring(0, startLength)}...${address.substring(
        address.length - endLength
      )}`
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  font-family: "Times New Roman", Times, serif;
}

::v-deep {
  .cs-dropdown {
    width: 100px;
    .dropdown-item {
      min-width: unset;
    }
  }
}
</style>

